import React, { Suspense, lazy, useEffect } from 'react';
import Subhero from "../subhero/Subhero";
import { Helmet } from "react-helmet";
import Placeholder from '../generic/Placeholder'

const Pricing = lazy(() => import("../pricing/Pricing"))
const ContactForm = lazy(() => import("../contact-form/ContactForm"))

const PageMailwallPricing = () => {
    return (
        <>
            <Helmet>
                <title>Mailwall - Advanced Email Security Made Simple</title>
                <meta name="description" content="Mailwall - advanced email filtering services for business. See how Omniquad's email protection can meet all your online security needs."/>
            </Helmet>
            <main className={"Page"}>
                <Subhero>
                    <h1>Advanced Email Security Made Simple</h1>
                </Subhero>
            </main>
            <Suspense fallback={<Placeholder />}>
                <Pricing/>
                <ContactForm variant={"mailwall"} />
            </Suspense>
        </>
    )
}

export default PageMailwallPricing;